export function checkIsNumberArray(value: unknown): value is number[] {
  return Array.isArray(value) && value.every((valueItem) => typeof valueItem === 'number');
}
